import VideoPage from './VideoPage'

export default VideoPage
// eslint-disable-next-line import/export
export * from './VideoPage'
